// fakedata of all rooms with all details

const rooms = [{
    image: "https://i.ibb.co/Rgn5FXk/Rectangle-26.png",
    heading: "Light bright airy stylish ap & safe peaceful stay",
    guest: 4,
    bedrooms: 2,
    beds: 2,
    bath: 2,
    star: "https://i.ibb.co/cktqx9D/star-1.png",
    rating: `4.9(5)`,
    price: `$34/night`,
    total: `$167`
  },
  {
    image: "https://i.ibb.co/7bqJPnt/Rectangle-27.png",
    heading: "Apartment In Lost panorama & safe peaceful journey",
    guest: 2,
    bedrooms: 2,
    beds: 1,
    bath: 1,
    star: "https://i.ibb.co/cktqx9D/star-1.png",
    rating: `4.5(5)`,
    price: `$30/night`,
    total: `$150`
  },
  {
    image: " https://i.ibb.co/MBJXv0N/Rectangle-28.png",
    heading: "AR Lounge & Pool(r&r + b&b )& beautiful moments",
    guest: 3,
    bedrooms: 3,
    beds: 3,
    bath: 2,
    star: "https://i.ibb.co/cktqx9D/star-1.png",
    rating: `4.7(5)`,
    price: `$38/night`,
    total: `$180`
  }]
  export default rooms;